import PropTypes from 'prop-types';
import React from 'react';

import {
  QUERY_PARAM_KEYS,
  QUERY_PARAM_VALUES,
} from '../../../constants/massOfferings/queryParamKeys';
import { useSearchParams } from '../../../hooks/useSearchParams';
import { AfterTransaction } from '../../MassOfferings';
import { AddMassOffering } from '../AddMassOffering/AddMassOffering';

export const InboxMassOfferingsContent = ({ inboxDictionary }) => {
  const urlSearchParams = useSearchParams();

  const isFromTransaction =
    urlSearchParams.get(QUERY_PARAM_KEYS.source) === QUERY_PARAM_VALUES.TRANSACTION;

  return isFromTransaction ? (
    <AfterTransaction />
  ) : (
    <AddMassOffering inboxDictionary={inboxDictionary} />
  );
};

InboxMassOfferingsContent.propTypes = {
  inboxDictionary: PropTypes.array.isRequired,
};
